const activityModuleList = ["groundFuels", "coProcessing", "saf"];

export default activityModuleList;
